import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-538394cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-heading"
}, [/*#__PURE__*/_createElementVNode("h3", null, "我的二维码")], -1));
const _hoisted_3 = {
  class: "qrcode-container"
};
const _hoisted_4 = {
  key: 0,
  class: "countdown-text"
};
const _hoisted_5 = {
  key: 1,
  class: "qrcode-tip"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-heading"
}, [/*#__PURE__*/_createElementVNode("h3", null, "我的活动")], -1));
const _hoisted_7 = {
  class: "event-dialog-body"
};
const _hoisted_8 = {
  class: "muted-line"
};
const _hoisted_9 = {
  class: "pagination"
};
const _hoisted_10 = {
  class: "home-content"
};
const _hoisted_11 = {
  key: 0,
  class: "profile-grid"
};
const _hoisted_12 = {
  class: "profile-hero glass-panel"
};
const _hoisted_13 = {
  class: "avatar-orb"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "profile-copy"
};
const _hoisted_17 = {
  class: "eyebrow"
};
const _hoisted_18 = {
  class: "profile-actions"
};
const _hoisted_19 = {
  class: "metrics-grid"
};
const _hoisted_20 = {
  class: "metric-label"
};
const _hoisted_21 = {
  class: "metric-value"
};
const _hoisted_22 = {
  key: 1,
  class: "info-board glass-panel"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "board-header"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "学习档案")]), /*#__PURE__*/_createElementVNode("p", null, "基础资料与二课学分")], -1));
const _hoisted_24 = {
  class: "field-grid"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: $setup.myQRVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.myQRVisible = $event),
    width: "420px",
    "align-center": "",
    "destroy-on-close": "",
    class: "soft-dialog"
  }, {
    header: _withCtx(() => [_hoisted_2]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [$setup.myQRVisible ? (_openBlock(), _createBlock(_component_vue_qrcode, {
      key: 0,
      value: $setup.qrcodeValue,
      options: {
        width: 220,
        margin: 1
      }
    }, null, 8, ["value"])) : _createCommentVNode("", true)]), $setup.myQRVisible ? (_openBlock(), _createElementBlock("p", _hoisted_4, [_createTextVNode(" 二维码将在 "), _createElementVNode("strong", null, _toDisplayString($setup.countdown), 1), _createTextVNode(" 秒后自动刷新 ")])) : _createCommentVNode("", true), $setup.myQRVisible ? (_openBlock(), _createElementBlock("p", _hoisted_5, " 动态身份码每 10 秒刷新一次；关闭弹窗后停止刷新。 ")) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $setup.myEventVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.myEventVisible = $event),
    width: "78%",
    "align-center": "",
    "destroy-on-close": "",
    class: "soft-dialog"
  }, {
    header: _withCtx(() => [_hoisted_6]),
    default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [$setup.eventList.length ? (_openBlock(), _createBlock(_component_el_table, {
      key: 0,
      data: $setup.eventList,
      stripe: "",
      style: {
        "width": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "id",
        label: "ID",
        width: "92"
      }), _createVNode(_component_el_table_column, {
        label: "活动名称",
        "min-width": "220"
      }, {
        default: _withCtx(scope => [_createElementVNode("strong", null, _toDisplayString(scope.row.title || scope.row.name || '未命名活动'), 1), _createElementVNode("small", null, _toDisplayString(scope.row.category || scope.row.statusName || '活动'), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "credit",
        label: "学分",
        width: "88"
      }), _createVNode(_component_el_table_column, {
        label: "时间",
        "min-width": "180"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString($setup.formatTime(scope.row.sTime)), 1), _createElementVNode("div", _hoisted_8, _toDisplayString($setup.formatTime(scope.row.eTime)), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "address",
        label: "活动地点",
        "min-width": "180"
      })]),
      _: 1
    }, 8, ["data"])) : (_openBlock(), _createBlock(_component_el_empty, {
      key: 1,
      description: "暂无活动记录"
    })), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
      onClick: $setup.prevPage,
      disabled: $setup.currentPage === 1
    }, {
      default: _withCtx(() => [_createTextVNode("上一页")]),
      _: 1
    }, 8, ["onClick", "disabled"]), _createElementVNode("span", null, "第 " + _toDisplayString($setup.currentPage) + " 页", 1), _createVNode(_component_el_button, {
      onClick: $setup.nextPage,
      disabled: !$setup.hasNextPage
    }, {
      default: _withCtx(() => [_createTextVNode("下一页")]),
      _: 1
    }, 8, ["onClick", "disabled"])])])), [[_directive_loading, $setup.eventLoading]])]),
    _: 1
  }, 8, ["modelValue"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [$setup.userProfile ? (_openBlock(), _createElementBlock("section", _hoisted_11, [_createElementVNode("article", _hoisted_12, [_createElementVNode("div", _hoisted_13, [$setup.avatarVisible ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.avatarUrl,
    alt: "头像",
    decoding: "async",
    referrerpolicy: "no-referrer",
    onError: _cache[2] || (_cache[2] = (...args) => $setup.handleAvatarError && $setup.handleAvatarError(...args))
  }, null, 40, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.initials), 1))]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString($setup.platformLabel), 1), _createElementVNode("h2", null, _toDisplayString($setup.displayName), 1), _createElementVNode("p", null, _toDisplayString($setup.userProfile.yx || '未获取学院') + " · " + _toDisplayString($setup.userProfile.major || '未获取专业'), 1)]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.generateQRCode
  }, {
    default: _withCtx(() => [_createTextVNode("身份码")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    onClick: $setup.getMyEvent
  }, {
    default: _withCtx(() => [_createTextVNode("我的活动")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "danger",
    plain: "",
    onClick: $setup.logout
  }, {
    default: _withCtx(() => [_createTextVNode("登出")]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.metricCards, metric => {
    return _openBlock(), _createElementBlock("article", {
      key: metric.label,
      class: "metric-card"
    }, [_createElementVNode("span", _hoisted_20, _toDisplayString(metric.label), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(metric.value), 1), _createElementVNode("small", null, _toDisplayString(metric.hint), 1)]);
  }), 128))])])) : _createCommentVNode("", true), $setup.userProfile ? (_openBlock(), _createElementBlock("section", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.profileFields, field => {
    return _openBlock(), _createElementBlock("div", {
      key: field.label,
      class: "field-tile"
    }, [_createElementVNode("span", null, _toDisplayString(field.label), 1), _createElementVNode("strong", null, _toDisplayString(field.value), 1)]);
  }), 128))])])) : _createCommentVNode("", true), !$setup.loading && !$setup.userProfile ? (_openBlock(), _createBlock(_component_el_empty, {
    key: 2,
    class: "empty-state glass-panel",
    description: "尚未加载个人信息，请先登录。"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.goLogin
    }, {
      default: _withCtx(() => [_createTextVNode("去登录")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })) : _createCommentVNode("", true)])), [[_directive_loading, $setup.loading]])]);
}